import { useCallback, useState } from 'react';
export function useOrder() {
  const [mode, setMode] = useState('asc');
  const [activeColumn, setActiveColumn] = useState(null);
  const changeOrder = useCallback(name => {
    if (activeColumn !== name) {
      setActiveColumn(name);
      setMode('asc');
    } else {
      if (mode === 'asc') {
        setMode('desc');
      } else if (mode === 'desc') {
        setActiveColumn(null);
        setMode('asc');
      }
    }
  }, [activeColumn, mode]);
  const resetOrder = useCallback(() => {
    setActiveColumn(null);
    setMode('asc');
  }, []);
  return {
    mode,
    activeColumn,
    changeOrder,
    resetOrder
  };
}